<template>
    <PageBaseLayout class="bottom-pad-override">
        <template #main>
            <div class="container">
                <div class="card celebrate">
                    <br>            
                    <div>
                        <h6>Congrats!</h6>
                        <p >
                            Your Address is now <span class="title small">whitelisted</span><br>
                            and you're officially a <span class="title small">Contributor</span>
                        </p>
                    </div>

                    <div class="divider"></div>

                    <div>
                        <p>Get ready for</p>
                        <h6 class="colored">1,000 rounds</h6>
                        <p>of</p>
                        <h6>Risk-Free Fun!</h6>
                    </div>
                </div>

            </div>
        </template>

        <template #bottom>
            <div class="bottom button-layout no-top">
                <BaseButton class="invite" @button-clicked="inviteFriends">
                    <img src="data:image/svg+xml;base64,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">
                    <p class="label huge prominent">Invite Friends to Contribute!</p>
                </BaseButton>
                <BaseButton class="hollow" pageId="HomePage">Back to Home &nbsp;<i class="icon middle home"></i></BaseButton>
            </div>
        </template>
    </PageBaseLayout>
</template>

<script>
import * as telegram from '@/telegramManager';

export default {
    methods: {
        inviteFriends() {
            const shareData = {
                title: "Alpha G.O.A.T",
                text: "Join us for 1000 RISK-FREE rounds!",
                url: "https://alphalabs.xyz",
            };

            if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
                navigator.share(shareData);
            } else {
                telegram.showPopupSimple('Invite Friends', 'Make sure to let your friends know, so they can benefit as well!');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.container .card {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 204px;
}

.divider {
    width: 200px;
    margin-top: 1rem;
    margin-bottom: 1rem;

    border: 1px solid #5675c4;
    border-radius: 6px;
}

.no-top {
    border: none;
}

.invite {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--color-bg);
    background-color: var(--color-secondary-variant);
}

.bottom-pad-override {
    --bottom-pad: 192px;
}

</style>